(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldSimple', fbFieldSimpleDirective);

    function fbFieldSimpleDirective(lodash, $timeout) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldSimpleDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldSimple',
            link: fbFieldSimpleDirectiveLink
        };

        function fbFieldSimpleDirectiveLink(scope, elem) {
            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }

            vm.inputType = vm.getType();

            if (vm.element.options.is_password) {
                vm.element.attr.element_class = {
                    'pr-8': vm.element.options.is_password,
                }
            }

            vm.passwordVisible = false;
            vm.togglePasswordVisibility = function () {
                $timeout(function () {
                    vm.passwordVisible = !vm.passwordVisible;
                    if (vm.passwordVisible) {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                })
            }
        }
    }

    function fbFieldSimpleDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.getType = function () {
                if (vm.element.type === 'smart-text-element') {
                    return 'text';
                }
                return vm.element.type;
            }
        }
    }
})();
